module.exports = __webpack_public_path__ + "media/assets/images/blank-hotel-583c2db14ff84acc65d29aaf603db5aa.jpg";